import { Regulation } from "../../../../autogen/bff-api";

// Standard Norwegian award-letter (tildelingsbrev) boilerplate. These are formal procurement-law
// texts rendered verbatim in the letters, so they are kept as Norwegian constants rather than i18n keys.
// The computed standstill (karens) expiry date is deferred — the clause references the period generically.

const senderOrFallback = (senderName?: string | null): string => senderName?.trim() || "oppdragsgiver";

export const winnerIntro = (eventTitle: string, senderName?: string | null): string =>
  `Vi viser til Deres tilbud i konkurransen om ${eventTitle}.\n\n` +
  `På vegne av ${senderOrFallback(senderName)} meddeles herved at kontrakten vil bli inngått med Deres firma.`;

export const rejectionIntro = (eventTitle: string, winnerName: string, senderName?: string | null): string =>
  `Vi viser til Deres tilbud i konkurransen om ${eventTitle}.\n\n` +
  `På vegne av ${senderOrFallback(senderName)} meddeles herved at kontrakten vil bli inngått med ${winnerName}.`;

export const signOff = (senderName?: string | null, signerName?: string | null): string =>
  ["Med vennlig hilsen,", signerName?.trim(), senderOrFallback(senderName)].filter(Boolean).join("\n");

export const winnerNamesText = (names: string[]): string =>
  names.length <= 1 ? (names[0] ?? "") : `${names.slice(0, -1).join(", ")} og ${names[names.length - 1]}`;

export const karensInfo = (regulation: Regulation | null | undefined): string => {
  const provision =
    regulation === Regulation.Forsyningsforskriften
      ? "forsyningsforskriften § 21-2"
      : "anskaffelsesforskriften § 25-2";
  return (
    `Det gjelder en karensperiode regnet fra denne meddelelsen er sendt, jf. ${provision}. ` +
    "Kontrakten vil ikke bli inngått før karensperioden er utløpt."
  );
};

export const KLAGE_INFO =
  "Eventuell klage på tildelingsbeslutningen kan rettes til oppdragsgiver eller til Klagenemnda for " +
  "offentlige anskaffelser (KOFA), Postboks 511 Sentrum, 5805 Bergen, eller per e-post post@kofa.no.";

export interface StatutoryClauseContext {
  eventRunsPrivateFlow: boolean;
  buyerRunsPublicProcurements: boolean;
  regulation: Regulation | null | undefined;
}

// FOA § 25-2 standstill never applies to the private flow (private buyer or FOA Part I), and KOFA
// (LOA § 7a) only hears complaints against public buyers.
export const statutoryClauses = ({
  eventRunsPrivateFlow,
  buyerRunsPublicProcurements,
  regulation,
}: StatutoryClauseContext): { standstill?: string; complaint?: string } => ({
  ...(eventRunsPrivateFlow ? {} : { standstill: karensInfo(regulation) }),
  ...(buyerRunsPublicProcurements ? { complaint: KLAGE_INFO } : {}),
});
